import { type HTMLAttributes, type ReactNode } from 'react';
import { cn } from '@/shared/lib/cn';
import './PageContainer.css';

export type ContainerWidth = 'sm' | 'md' | 'lg' | 'full';

export interface PageContainerProps extends HTMLAttributes<HTMLDivElement> {
  width?: ContainerWidth;
  children: ReactNode;
}

/**
 * Wrapper opcional del contenido de página cuando se necesita un ancho
 * menor al default del AppShell (ej: formularios, lectura).
 *   sm: 560px · md: 880px · lg: 1280px (default) · full: sin límite.
 */
export function PageContainer({
  width = 'lg',
  children,
  className,
  ...rest
}: PageContainerProps) {
  return (
    <div className={cn('itb-container', `itb-container--${width}`, className)} {...rest}>
      {children}
    </div>
  );
}
